import * as Types from 'types';

export namespace BrowseFilters {
  // Artist Type
  export const LABELED_ARTIST_TYPES: Record<Types.ArtistTypes, string> = {
    curated: 'Curated',
    op: 'Open Platform',
  };

  // Orders
  export const ORDER_TYPES = [
    'date',
    'followers',
    'collectors',
    'alphabetical',
    'popularity',
  ] as const;
  export type OrderTypes = typeof ORDER_TYPES[number];
  export const LABELED_ORDER_TYPES: Record<OrderTypes, string> = {
    date: 'Latest',
    popularity: 'Popular',
    followers: 'Most followed',
    collectors: 'Most collected',
    alphabetical: 'Alphabetical',
  };
}

export type ArtworkListConfigurationParams = {
  type: Types.ArtistTypes;
  order: BrowseFilters.OrderTypes;
};
